import React from "react";
import { Redirect, Route } from "react-router-dom";
import { isAuthenticated } from "../../../../service/auth";

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ patname: "/admin", state: { from: props.location } }} />
      )
    }
  />
);

export default AdminRoute;
